import { toSnake } from "snake-camel";

/**
 * Convert camel case object to snake case.
 * Handles when object is an array which `snake-camel` does not.
 */
export const convertToSnake = <T>(value: unknown) => {
  const toConvert = {
    data: value,
  };

  const converted = toSnake(toConvert) as { data: T };
  return converted.data;
};
